import React, { useEffect } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "rebass/styled-components";
import styled from "styled-components";
import { ThunkDispatch } from "core-integration/src/store";
import { updateElementControls } from "core-integration/src/store/elements/actions";
import {
  getElementControls,
  getElementsFromControls,
} from "core-integration/src/store/elements/reducers";
import { updateElementControlsAndMaxCost } from "core-integration/src/store/elements/thunks";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import ElementFilter from "../element-controls/ElementFilter";
import ElementSort from "../element-controls/ElementSort";
import ElementDialogButton from "../ElementDialogButton";
import ElementInTable from "../ElementInTable";
import { ElementRow, ElementTable } from "../ElementTable";
import { FieldCol, FieldCols } from "../FieldRenderers";
import { Main, Wrapper } from "../Layout";
import ScoutNav from "../scout/ScoutNav";
import Title from "../Title";

const NewsStatus = styled.th`
  width: 10%;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 6%;
  }
`;

const NewsElement = styled.th`
  width: 39%;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 38%;
  }
`;

const NewsNews = styled.th`
  width: 51%;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 56%;
  }
`;

const NewsCell = styled.td`
  white-space: normal;
`;

const NavWrap = styled.div`
  width: 100%;
  margin: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 75%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    width: 50%;
  }
`;

type Props = WithTranslation;

const News = ({ t }: Props) => {
  const dispatch = useDispatch<ThunkDispatch>();

  const controls = useSelector(getElementControls);
  const elements = useSelector(getElementsFromControls);
  const teamsById = useSelector(getTeamsById);

  const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(
      updateElementControls({
        ...controls,
        filter: e.target.value,
      }),
    );
  };

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(
      updateElementControls({
        ...controls,
        sort: e.target.value,
      }),
    );
  };

  useEffect(() => {
    dispatch(
      updateElementControlsAndMaxCost({
        ...controls,
        filter: "all",
        sort: "news_added",
      }),
    );
  }, []);

  return (
    <>
      <Wrapper>
        <NavWrap>
          <ScoutNav />
        </NavWrap>
      </Wrapper>
      <Wrapper>
        <Main>
          <Box mx={2}>
            <Title>{t("news.title", "Player Availability")}</Title>
          </Box>
          <form>
            <FieldCols>
              <FieldCol>
                <ElementFilter handleFilterChange={handleFilterChange} />
              </FieldCol>
              <FieldCol>
                <ElementSort
                  handleSortChange={handleSortChange}
                  sortOptions={[
                    {
                      label: t("news.sortMostRecent", "Most recently added"),
                      value: "news_added",
                    },
                    {
                      label: t("news.sortChanceOfPlaying", "Chance of playing"),
                      value: "chance_of_playing_next_round",
                    },
                  ]}
                />
              </FieldCol>
            </FieldCols>
          </form>
          <ElementTable>
            <thead>
              <tr>
                <NewsStatus>&nbsp;</NewsStatus>
                <NewsElement>{t("news.playerCol", "Player")}</NewsElement>
                <NewsNews>{t("news.newsCol", "News")}</NewsNews>
              </tr>
            </thead>
            <tbody>
              {elements.data
                .filter((e) => e.news)
                .map((e) => (
                  <ElementRow key={e.id}>
                    <td>
                      <ElementDialogButton elementId={e.id} variant="list" />
                    </td>
                    <td>
                      <ElementInTable
                        renderElementMenu={() => {
                          window.console.log("not needed");
                        }}
                        element={e}
                        team={teamsById[e.team]}
                      />
                    </td>
                    <NewsCell>{e.news}</NewsCell>
                  </ElementRow>
                ))}
            </tbody>
          </ElementTable>
        </Main>
      </Wrapper>
    </>
  );
};

export default withTranslation()(News);
